<template>
	<div>
		<Loading v-if="loadingMeta" text="Lade Daten..."/>
		<template v-else>
			<template v-if="!meta.customerDataComplete">
				<CompleteData
					:customer="customer"
					@complete="onCompleteData"
				/>
			</template>
			<template v-else-if="!meta.canContact && meta.voucher">
				<b-row>
					<b-col md="7">
						<PriceTable
							:with-free="false"
							:with-prices="false"
							:only-product-id="meta.voucher.productId"
						/>
					</b-col>
					<b-col md="5">
						<JonInfo class="mt-0" footer-image="/img/customer_voucher.png">
							<template #message>
								<h3>Yeah, du hast einen Gutschein für "{{meta.voucher.productLabel}}"!</h3>
								<p>
									Damit kannst du <b>{{ meta.voucher.duration }} Tage</b> lang bis zu
									<b>{{ meta.voucher.contactingsPerMonth }} KandidatInnen</b> kontaktieren.
								</p>
								<p class="mt-3 mb-5">
									Klicke jetzt unten auf "Gutschein einlösen", um deine gratis Testphase zu beginnen!
								</p>
							</template>
						</JonInfo>
					</b-col>
				</b-row>
				<div class="mt-4">
					<Button
						text="Gutschein einlösen"
						icon="checkmark"
						:loading="usingVoucher"
						:disabled="usingVoucher"
						@click="useVoucher"
					/>
				</div>
			</template>
			<template v-else>
				<FormGroup :label="firstQuestionLabel" :label-classes="['font-weight-bold']">
					<div>
						<div v-if="isTypeHire">
							Deine Zusage für eine Zusammenarbeit wird der Person sofort zugestellt.
						</div>
						<JonInfo v-else>
							<template #message>
								<div v-if="isInitiatorCustomer">
									<div class="font-weight-bold">Möchtest du die Person kontaktieren?</div>
									<div>Das passiert, wenn du <b>"Jetzt kontaktieren"</b> klickst:</div>
									<ol class="pl-3 mt-3">
										<li>Wir senden deine Kontaktanfrage an die Person.</li>
										<li>
											Die Person sieht dein anonymes Jobprofil und das "Matching"/die
											Übereinstimmung.
										</li>
										<li>
											Nimmt die Person deine anonyme Kontaktanfrage an, dann erfährt sie den Namen
											eurer Organisation und deinen Namen.
										</li>
										<li>
											Danach kann die Person entscheiden, ob sie an weiteren Schritten
											interessiert ist und ihren eigenen Namen offenlegt und du erhältst eine
											entsprechende Nachricht.
										</li>
									</ol>
									<div>Viel Erfolg!</div>
								</div>
								<div v-else>
									<div class="font-weight-bold">
										Möchtest Du die Kontaktanfrage von der Person mit dem Profil
										{{ pseudonym.label }} annehmen?
									</div>
									<div>Das passiert, wenn du <b>"Kontaktanfrage annehmen"</b> klickst:</div>
									<ol class="pl-3 mt-3">
										<li>Die Person erfährt den Namen eurer Organisation und deinen Namen.</li>
										<li>Danach kann die Person entscheiden, ob sie an weiteren Schritten
											interessiert ist und ihren eigenen Namen offenlegt und du erhältst eine
											entsprechende Nachricht.
										</li>
									</ol>
									<div>Viel Erfolg!</div>
								</div>
								<!--<div>Folgende deiner Infos werden dabei geteilt:</div>
								<div class="font-weight-bold">
									{{ customer.fullName }}<br/>
									<template v-if="customer.role">{{ customer.role }}<br/></template>
									{{ customer.companyName }}
									<template v-if="customer.website"><br/>{{ customer.website }}</template>
								</div>-->
							</template>
						</JonInfo>
					</div>
					<div class="mt-4">
						<b-form-checkbox
							v-model="shouldContact"
							:disabled="!meta.canContact"
							class="mt-3"
							@change="emitChangeEvent"
						>
							{{ confirmContactLabel }}
						</b-form-checkbox>
						<div v-if="!meta.canContact" class="mt-1 error font-size-big">
							Du hast kein aktives Abonnement oder die Anzahl der maximalen Kontaktierungen pro Monat
							bereits erreicht.
						</div>
					</div>
				</FormGroup>
				<div v-if="meta.customerDataComplete" class="d-flex align-items-center mt-4">
					<div class="flex-grow-1">
						<Button
							:text="isTypeAccept ? 'Kontaktanfrage annehmen' : 'Jetzt kontaktieren'"
							icon="checkmark"
							:disabled="!dataValid || contacting"
							:loading="contacting"
							@click="contact"
						/>
					</div>
					<div v-if="!meta.canContact">
						<Button
							v-if="purchasingSubscription"
							text="Ich habe ein Abonnement erworben"
							icon="coins"
							@click="onPurchasedSubscription"
						/>
						<Button
							v-else
							text="Abonnement bearbeiten"
							icon="coins"
							@click="purchaseSubscription"
						/>
					</div>
				</div>
			</template>
			<!--<TokenCostInfo
				v-if="shouldContact"
				class="mt-4"
				:text-singular="conversationCostInfoTextSingular"
				:text-plural="conversationCostInfoTextPlural"
				:tokens="meta.conversationProduct.tokenAmount"
			/>-->
		</template>
	</div>
</template>

<script>
import TokenCostInfo from "@/vue/communication/TokenCostInfo";
import InfoBox from "@/vue/common/InfoBox";
import ArrowLink from "@/vue/common/ArrowLink";
import Loading from "@/vue/common/Loading";
import FormGroup from "@/vue/common/form/Group";
import {mapActions, mapState} from "vuex";
import Meta from "@/api/communication/conversation/applicant/Meta";
import Button from "@/vue/common/Button";
import flatten from "@/helper/error/Errors";
import Contact from "@/api/communication/conversation/applicant/Contact";
import CompleteData from "@/vue/customer/CompleteData";
import JonInfo from "@/vue/common/JonInfo.vue";
import * as Toast from "@/helper/layout/Toast";
import PriceTable from "@/vue/payment/PriceTable.vue";
import Redeem from "@/api/customer/subscription/voucher/Redeem";
import {error} from "@/helper/Log";

const TYPE_HIRE = 'hire';
const TYPE_ACCEPT = 'accept';

const INITIATOR__CUSTOMER = 'customer';

export default {

	components: {
		PriceTable,
		JonInfo,
		CompleteData,
		Button,
		TokenCostInfo,
		InfoBox,
		ArrowLink,
		Loading,
		FormGroup,
	},

	props: {
		jobProfileId: {
			type: String,
			required: true,
		},
		jobId: {
			type: String,
			required: true,
		},
		pseudonym: {
			type: Object,
			required: true,
		},
		initiator: {
			type: String,
			required: true
		},
		type: {
			type: String,
			required: false,
		},
		conversation: {
			type: Object,
			required: false,
		},
	},

	mounted ()
	{
		this.loadMeta();
	},

	data ()
	{
		return {
			shouldContact: false,
			loadingMeta: true,
			meta: null,
			contacting: false,
			purchasingSubscription: false,
			usingVoucher: false,
		};
	},

	computed: {
		...mapState('auth', [
			'customer'
		]),
		isInitiatorCustomer ()
		{
			return this.initiator === INITIATOR__CUSTOMER;
		},
		isTypeAccept ()
		{
			return this.type === TYPE_ACCEPT;
		},
		isTypeHire ()
		{
			return this.type === TYPE_HIRE;
		},
		firstQuestionLabel ()
		{
			return this.isTypeHire
				? 'Willst du der Person sofort eine Zusage zur Zusammenarbeit schicken?'
				: null;
		},
		confirmContactLabel ()
		{
			let text = this.isInitiatorCustomer
				? 'Ja, ich möchte die Person kontaktieren.'
				: 'Ja, ich will die Kontaktanfrage annehmen.';

			text += ' Dabei wird 1 Kontaktierung von meinem Guthaben abgezogen.';

			return text;
		},
		dataValid ()
		{
			return this.shouldContact;
		},
	},

	methods: {
		...mapActions('auth', {
			'reloadAuth': 'load'
		}),
		async useVoucher ()
		{
			this.usingVoucher = true;

			try
			{
				await new Redeem()
					.call();

				await this.loadMeta();
			}
			catch (e)
			{
				error(e);
				Toast.error(this, flatten(e.errors, 'Fehler beim Einlösen des Gutscheins'));
			}

			this.usingVoucher = false;
		},
		async loadMeta ()
		{
			this.loadingMeta = true;

			const response = await new Meta()
				.setPseudonym(this.pseudonym.id)
				.setJobProfile(this.jobProfileId)
				.setJob(this.jobId)
				.call();

			this.meta = response.data;

			if (this.meta.alreadyDisclosed)
			{
				this.$emit('alreadyDisclosed');
			}

			this.$emit('customerDataComplete', this.meta.customerDataComplete);
			this.$emit('canAffordConversation', this.meta.canAffordConversation);

			this.loadingMeta = false;
		},
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				contact: true
			});
		},
		onPurchasedSubscription ()
		{
			this.purchasingSubscription = false;

			this.loadMeta();
		},
		purchaseSubscription ()
		{
			this.purchasingSubscription = true;

			window.open('/kundenbereich/verrechnung?openPurchaseSubscriptionPopUp=1');
		},
		async onCompleteData ()
		{
			await this.reloadAuth();

			this.loadMeta();
		},
		async contact ()
		{
			this.contacting = true;

			try
			{
				await new Contact()
					.setConversation(this.conversation?.id)
					.setPseudonym(this.pseudonym.id)
					.setJobProfile(this.jobProfileId)
					.setJob(this.jobId)
					.call();

				this.$emit('purchase');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.contacting = false;
		}
	}
}
</script>
